var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Translate } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";
import { Icon } from "../../UI";
import React, { useMemo } from 'react';
import { bindActionCreators } from 'redux';


import {
uploadDocument as uploadDocumentAction,
createDocument as createDocumentAction } from "../../Uploads/actions/uploadsActions";


import { unselectAllDocuments as unselectAllDocumentsAction } from "../actions/libraryActions";
import { connect } from 'react-redux';

const extractTitle = (file) => {
  const title = file.name.
  replace(/\.[^/.]+$/, '').
  replace(/_/g, ' ').
  replace(/-/g, ' ').
  replace(/ {2}/g, ' ');

  return title.charAt(0).toUpperCase() + title.slice(1);
};













const onChangePDFs =
({ createDocument, uploadDocument, unselectAllDocuments }) =>
(e) => {
  const { files } = e.target;
  const count = (files === null || files === void 0 ? void 0 : files.length) || 0;

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < count; index++) {
    const file = files[index];
    const doc = { title: extractTitle(file) };
    createDocument(doc).
    then((newDoc) => {
      uploadDocument(newDoc.sharedId, file);
    }).
    catch(() => {});
  }

  unselectAllDocuments();
};

const PDFUploadButtonComponent = ({
  createDocument,
  uploadDocument,
  unselectAllDocuments
}) => {
  const onChangeHandler = useMemo(
  () =>
  onChangePDFs({
    createDocument,
    uploadDocument,
    unselectAllDocuments
  }),
  [createDocument, uploadDocument, unselectAllDocuments]);


  return /*#__PURE__*/(
    _jsx("label", { htmlFor: "pdf-upload-button", className: "btn btn-default" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "cloud-upload-alt" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Upload PDF(s) to create")), /*#__PURE__*/

    _jsx("input", {
      type: "file",
      id: "pdf-upload-button",
      style: { display: 'none' },
      accept: "application/pdf",
      multiple: true,
      onChange: onChangeHandler })));



};

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
  {
    uploadDocument: uploadDocumentAction,
    unselectAllDocuments: unselectAllDocumentsAction,
    createDocument: createDocumentAction
  },
  wrapDispatch(dispatch, props.storeKey));

}

export const PDFUploadButton = connect(
null,
mapDispatchToProps)(
PDFUploadButtonComponent);